import config from './config'
import { history, store } from './App'

export function verifyEmail (value) {
  const emailRex = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (emailRex.test(value)) {
    return true
  }
  return false
}

export function isNumber (value) {
  const numRex = /^[0-9\b]+$/
  if (numRex.test(value)) {
    return true
  }
  return false
}

export function verifyPassword (value) {
  const passwordRex = /^[\S]{8,15}$/
  if (passwordRex.test(value)) {
    return true
  }
  return false
}

export function verifyLength (value, length) {
  if (value && ((value + '').length >= length)) {
    return true
  }
  return false
}
export function getUrl (bucketUrl) {
  if (bucketUrl === 'kyc') return config.KYC_URL
  return config.MEDIA_BUCKET_URL
}

export async function unAuthorized () {
  localStorage.removeItem('Token')
  store.dispatch({
    type: 'TOKEN_LOGIN',
    payload: {
      token: null
    }
  })
  history.push('/auth')
}
